// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"756":"df59300f","898":"df59300f"}[chunkId] + ".chunk.css";
};